import {
  MarksState,
  CREATE_FINAL_MARK_STARTED,
  UPDATE_FINAL_MARK_STARTED,
  CREATE_PARTIAL_MARK_STARTED,
  UPDATE_PARTIAL_MARK_STARTED,
  DELETE_PARTIAL_MARK_STARTED,
  CREATE_FINAL_MARK_SUCCESS,
  UPDATE_FINAL_MARK_SUCCESS,
  CREATE_PARTIAL_MARK_SUCCESS,
  UPDATE_PARTIAL_MARK_SUCCESS,
  DELETE_PARTIAL_MARK_SUCCESS,
  CREATE_FINAL_MARK_FAIL,
  UPDATE_FINAL_MARK_FAIL,
  CREATE_PARTIAL_MARK_FAIL,
  UPDATE_PARTIAL_MARK_FAIL,
  DELETE_PARTIAL_MARK_FAIL,
  CREATE_FINAL_MARKS_STARTED,
  UPDATE_FINAL_MARKS_STARTED,
  CREATE_PARTIAL_MARKS_STARTED,
  UPDATE_PARTIAL_MARKS_STARTED,
  DELETE_PARTIAL_MARKS_STARTED,
  CREATE_FINAL_MARKS_SUCCESS,
  UPDATE_FINAL_MARKS_SUCCESS,
  CREATE_PARTIAL_MARKS_SUCCESS,
  UPDATE_PARTIAL_MARKS_SUCCESS,
  DELETE_PARTIAL_MARKS_SUCCESS,
  CREATE_FINAL_MARKS_FAIL,
  UPDATE_FINAL_MARKS_FAIL,
  CREATE_PARTIAL_MARKS_FAIL,
  UPDATE_PARTIAL_MARKS_FAIL,
  DELETE_PARTIAL_MARKS_FAIL,
  OPEN_SIGN_MARK_MODAL,
  CLOSE_SIGN_MARK_MODAL,
  CANCEL_SIGN_MARKS,
  SIGN_MARKS_START,
  SIGN_MARKS_SUCCESS,
  SIGN_MARKS_FAIL,
  OPEN_CONFIRM_CODE_MARK_MODAL,
  CLOSE_CONFIRM_CODE_MARK_MODAL,
  CONFIRM_CODE_START,
  CONFIRM_SMS_CODE_SUCCESS,
  CONFIRM_SMS_CODE_FAIL,
  CONFIRM_EMAIL_CODE_SUCCESS,
  CONFIRM_EMAIL_CODE_FAIL,
  OPEN_EMPLOYEE_CONFIRM_MARK_MODAL,
  CLOSE_EMPLOYEE_CONFIRM_MARK_MODAL,
  SET_EMPLOYEE_CONFIRM_MARK_MODAL,
  EMPLOYEE_CONFIRM_START,
  EMPLOYEE_CONFIRM_SUCCESS,
  EMPLOYEE_CONFIRM_FAIL,
  OPEN_EMPLOYEE_CODE_MARK_MODAL,
  CLOSE_EMPLOYEE_CODE_MARK_MODAL,
  EMPLOYEE_CODE_START,
  EMPLOYEE_CODE_SUCCESS,
  EMPLOYEE_CODE_FAIL,
  FINAL_CONFIRM_START,
  FINAL_CONFIRM_SUCCESS,
  FINAL_CONFIRM_FAIL,
  DELETE_FINAL_MARK_STARTED,
  DELETE_FINAL_MARK_SUCCESS,
  DELETE_FINAL_MARK_FAIL,
} from './types';
import { AnyAction } from 'redux';
import { RESET_REDUCERS } from '../auth/types';

const initState: MarksState = {
  mainLoader: false,
  partialMarks: {
    loading: false,
    error: false,
  },
  finalMarks: {
    loading: false,
    error: false,
  },
  signing: {
    studentList: [],
    semestrAkademicki: null,
    rokAkademicki: null,
    przedmiotKod: null,
    wydzialZlecajacyKod: null,
    wydzialZlecajacyNazwa: null,
    przedmiotNazwa: null,
    opened: false,
    loading: false,
    error: false,
    controlSum: null,
    tabId: null,
  },
  codeConfirmModal: {
    opened: false,
    loading: false,
    error: false,
    mode: 'sms',
  },
  emailEmployeeCodeConfirmModal: {
    opened: false,
    loading: false,
    error: false,
  },
  employeeConfirmModal: {
    opened: false,
    value: null,
    loading: false,
    error: false,
    list: [],
  },
};

export default function authReducer(
  state: MarksState = initState,
  action: AnyAction
): MarksState {
  switch (action.type) {
    case FINAL_CONFIRM_START:
      return {
        ...state,
        mainLoader: true,
      };
    case FINAL_CONFIRM_SUCCESS:
      return {
        ...initState,
      };
    case FINAL_CONFIRM_FAIL:
      return {
        ...initState,
      };

    case OPEN_EMPLOYEE_CODE_MARK_MODAL:
      return {
        ...state,
        emailEmployeeCodeConfirmModal: { ...state.emailEmployeeCodeConfirmModal, opened: true },
      };
    case CLOSE_EMPLOYEE_CODE_MARK_MODAL:
      return {
        ...state,
        emailEmployeeCodeConfirmModal: { ...initState.emailEmployeeCodeConfirmModal },
      };
    case EMPLOYEE_CODE_START:
      return {
        ...state,
        emailEmployeeCodeConfirmModal: { ...state.emailEmployeeCodeConfirmModal, loading: true },
      };
    case EMPLOYEE_CODE_SUCCESS:
      return {
        ...state,
        emailEmployeeCodeConfirmModal: { ...state.emailEmployeeCodeConfirmModal, loading: false, error: false },
      };
    case EMPLOYEE_CODE_FAIL:
      return {
        ...state,
        emailEmployeeCodeConfirmModal: { ...state.emailEmployeeCodeConfirmModal, loading: false, error: true },
      };
    case OPEN_EMPLOYEE_CONFIRM_MARK_MODAL:
      return {
        ...state,
        employeeConfirmModal: { ...state.employeeConfirmModal, opened: true },
      };
    case CLOSE_EMPLOYEE_CONFIRM_MARK_MODAL:
      return {
        ...state,
        employeeConfirmModal: { ...initState.employeeConfirmModal },
      };
    case SET_EMPLOYEE_CONFIRM_MARK_MODAL:
      return {
        ...state,
        employeeConfirmModal: { ...state.employeeConfirmModal, value: action.payload.value },
      };
    case EMPLOYEE_CONFIRM_START:
      return {
        ...state,
        employeeConfirmModal: { ...state.employeeConfirmModal, loading: true },
      };
    case EMPLOYEE_CONFIRM_SUCCESS:
      return {
        ...state,
        employeeConfirmModal: { ...state.employeeConfirmModal, loading: false, error: false, opened: false },
      };
    case EMPLOYEE_CONFIRM_FAIL:
      return {
        ...state,
        employeeConfirmModal: { ...state.employeeConfirmModal, loading: false, error: true },
      };
    case OPEN_CONFIRM_CODE_MARK_MODAL:
      return {
        ...state,
        codeConfirmModal: { ...state.codeConfirmModal, opened: true, mode: action.payload.mode },
      };
    case CLOSE_CONFIRM_CODE_MARK_MODAL:
      return {
        ...state,
        codeConfirmModal: { ...initState.codeConfirmModal },
      };
    case CONFIRM_CODE_START:
      return {
        ...state,
        codeConfirmModal: { ...state.codeConfirmModal, loading: true },
      };
    case CONFIRM_SMS_CODE_SUCCESS:
      return {
        ...state,
        codeConfirmModal: { ...state.codeConfirmModal, loading: false, error: false },
      };
    case CONFIRM_EMAIL_CODE_SUCCESS:
      return {
        ...state,
        codeConfirmModal: {
          ...state.codeConfirmModal,
          loading: false,
          error: false,
          opened: false,
        },
        employeeConfirmModal: {
          ...state.employeeConfirmModal,
          list: action.payload.list,
        },
      };
    case CONFIRM_SMS_CODE_FAIL:
    case CONFIRM_EMAIL_CODE_FAIL:
      return {
        ...state,
        codeConfirmModal: { ...state.codeConfirmModal, loading: false, error: true },
      };
    case SIGN_MARKS_START:
      return {
        ...state,
        signing: { ...state.signing, loading: true },
      };
    case SIGN_MARKS_SUCCESS:
      return {
        ...state,
        signing: {
          ...state.signing,
          loading: false,
          error: false,
          controlSum: action.payload.data.controlSum,
        },
      };
    case SIGN_MARKS_FAIL:
      return {
        ...state,
        signing: { ...state.signing, loading: false, error: true },
      };
    case CANCEL_SIGN_MARKS:
      return {
        ...state,
        signing: { ...initState.signing },
        codeConfirmModal: { ...initState.codeConfirmModal },
        emailEmployeeCodeConfirmModal: { ...initState.emailEmployeeCodeConfirmModal },
        employeeConfirmModal: { ...initState.employeeConfirmModal },
        mainLoader: false,
      };
    case OPEN_SIGN_MARK_MODAL:
      return {
        ...state,
        signing: {
          ...initState.signing,
          opened: true,
          studentList: action.payload.studentList,
          semestrAkademicki: action.payload.semestrAkademicki,
          rokAkademicki: action.payload.rokAkademicki,
          przedmiotKod: action.payload.przedmiotKod,
          wydzialZlecajacyKod: action.payload.wydzialZlecajacyKod,
          wydzialZlecajacyNazwa: action.payload.wydzialZlecajacyNazwa,
          przedmiotNazwa: action.payload.przedmiotNazwa,
          tabId: action.payload.tabId,
        },
        codeConfirmModal: { ...initState.codeConfirmModal },
        emailEmployeeCodeConfirmModal: { ...initState.emailEmployeeCodeConfirmModal },
        employeeConfirmModal: { ...initState.employeeConfirmModal },
        mainLoader: false,
      };
    case CLOSE_SIGN_MARK_MODAL:
      return {
        ...state,
        signing: { ...state.signing, opened: false },
      };
    // tworzenie / edycja oceny końcowej
    case CREATE_FINAL_MARK_STARTED:
    case UPDATE_FINAL_MARK_STARTED:
    case CREATE_FINAL_MARKS_STARTED:
    case UPDATE_FINAL_MARKS_STARTED:
    case DELETE_FINAL_MARK_STARTED:
      return {
        ...state,
        finalMarks: {
          ...state.finalMarks,
          loading: true,
        },
      };
    case CREATE_FINAL_MARK_SUCCESS:
    case UPDATE_FINAL_MARK_SUCCESS:
    case DELETE_FINAL_MARK_SUCCESS:
    case CREATE_FINAL_MARKS_SUCCESS:
    case UPDATE_FINAL_MARKS_SUCCESS:
      return {
        ...state,
        finalMarks: {
          ...state.finalMarks,
          loading: false,
        },
      };
    case CREATE_FINAL_MARK_FAIL:
    case UPDATE_FINAL_MARK_FAIL:
    case CREATE_FINAL_MARKS_FAIL:
    case UPDATE_FINAL_MARKS_FAIL:
    case DELETE_FINAL_MARK_FAIL:
      return {
        ...state,
        finalMarks: {
          ...state.finalMarks,
          loading: false,
          error: true,
        },
      };
    // tworzenie / edycja / usuwanie oceny cząstkowej
    case CREATE_PARTIAL_MARK_STARTED:
    case UPDATE_PARTIAL_MARK_STARTED:
    case DELETE_PARTIAL_MARK_STARTED:
    case CREATE_PARTIAL_MARKS_STARTED:
    case UPDATE_PARTIAL_MARKS_STARTED:
    case DELETE_PARTIAL_MARKS_STARTED:
      return {
        ...state,
        partialMarks: {
          ...state.partialMarks,
          loading: true,
        },
      };
    case CREATE_PARTIAL_MARK_SUCCESS:
    case UPDATE_PARTIAL_MARK_SUCCESS:
    case DELETE_PARTIAL_MARK_SUCCESS:
    case CREATE_PARTIAL_MARKS_SUCCESS:
    case UPDATE_PARTIAL_MARKS_SUCCESS:
    case DELETE_PARTIAL_MARKS_SUCCESS:
      return {
        ...state,
        partialMarks: {
          ...state.partialMarks,
          loading: false,
        },
      };
    case CREATE_PARTIAL_MARK_FAIL:
    case UPDATE_PARTIAL_MARK_FAIL:
    case DELETE_PARTIAL_MARK_FAIL:
    case CREATE_PARTIAL_MARKS_FAIL:
    case UPDATE_PARTIAL_MARKS_FAIL:
    case DELETE_PARTIAL_MARKS_FAIL:
      return {
        ...state,
        partialMarks: {
          ...state.partialMarks,
          loading: false,
          error: true,
        },
      };
    case RESET_REDUCERS:
      // reset danych stora
      return {
        ...initState,
      };
    default:
      return state;
  }
}
